<template>
    <div id="filter" class="mb-3">
        <div class="row g-0">
            <div class="col-sm-6 col-xl">
                <div class="px-3 pt-1 mb-1">
                    <small :class="{active: searchByHotel}" class="me-2" @click="searchByHotel = true">{{ $t('message.filter.hotel_title') }}</small>
                    <small :class="{active: !searchByHotel}" @click="searchByHotel = false">{{ $t('message.filter.claim') }}</small>
                </div>
                <filter-dropdown v-model="hotel_id" :notSelectedLabel="$t('message.filter.select_value')" v-show="searchByHotel"
                    :items="hotels" />
                <filter-input v-model="claim"
                    v-show="!searchByHotel"
                    :notSelectedLabel="$t('message.filter.input_label')"
                    :class="{'invalid': (v$.$dirty && v$.claim.$invalid)}" />
            </div>
            <div class="col-sm-6 col-xl">
                <filter-dropdown v-model="status" :notSelectedLabel="$t('message.filter.select_value')"
                    :items="statuses" :title="$t('message.filter.status_title')" />
            </div>
            <div class="col-sm-6 col-xl">
                <filter-dropdown v-model="sort" :notSelectedLabel="$t('message.filter.select_value')"
                    :items="sortOptions" :title="$t('message.filter.sort_title')" />
            </div>
            <div class="col-sm-6 col-xl">
                <div class="filter-button-container">
                    <filter-button v-model="loading" @click-event="search" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MessageFilterResult from 'modules/messages/MessageFilterResult.vue'
import FilterInput from 'components/filter/FilterInput.vue'
import FilterDropdown from 'components/filter/FilterDropdown.vue'
import FilterButton from 'components/filter/FilterButton.vue'
import screenMixin from 'mixins/screen'
import translateMixin from 'mixins/translate'
import { mapState } from 'vuex'
import { useVuelidate } from '@vuelidate/core'
import { required, integer, maxLength } from '@vuelidate/validators'

export default {
    name: 'MessageFilter',
    data() {
        return {
            v$: useVuelidate(),

            searchByHotel: true,
            claim: null,
            status: null,
            sort: null,
            hotel_id: null,
            page: 2,

            statuses: [
                { value: '', label: this.$root.$t('message.filter.status_any') },
                { value: 1, label: this.$root.$t('message.filter.status_read') },
                { value: 2, label: this.$root.$t('message.filter.status_unread') }
            ],
            sortOptions: [
                { value: 0, label: this.$root.$t('message.filter.sort_none') },
                { value: 1, label: this.$root.$t('message.filter.sort_date') },
                { value: 2, label: this.$root.$t('message.filter.sort_claim') }
            ],

            isMobile: false,
            showFilter: false
        }
    },
    validations: {
        claim: {
            required,
            integer,
            maxLength: maxLength(8)
        },
    },
    components: {
        FilterInput, FilterDropdown, FilterButton, MessageFilterResult
    },
    computed: {
        ...mapState({
            hotels: state => state.messages.hotels,
            messages: state => state.messages.messages,
            loading: state => state.messages.loading,
            isEmptyMessages: state => state.messages.isEmptyMessages,
            messagesInfo: state => state.messages.messagesInfo
        }),
    },
    methods: {
        search() {
            // this.v$.claim.$validate();
            // if (this.v$.claim.$invalid) {
            //     this.v$.claim.$touch;
            //     return;
            // }
            const params = {
                claim_id: this.claim,
                hotel_id: this.hotel_id,
                status: this.status,
                sort: this.sort,
                page_number: 1
            };
            this.$store.dispatch('messages/getMessages', params);
        },
        reset(){
            this.claim = null;
            this.status = null;
            this.sort = null;
        }
    },
    watch: {
        messages(messages){
            this.showFilter = messages.length === 0
        },
        isMobile(isMobile){
            if(isMobile)
                this.showFilter = this.messages.length === 0
        }
    },
    mixins: [
        screenMixin, translateMixin
    ],
    mounted(){
        this.$store.dispatch('messages/getHotels');
    }
}
</script>

<style scoped>
#show_filter + #filter{
    margin-top: 1rem;
}
.filter-button-container {
    padding: 13px;
}

#filter .row>div:not(:last-child) {
    border-right: 1px solid #f5f5f5;
}

#filter > .row > div{
    border-bottom: 1px solid #f5f5f5;
}

#filter>.row:last-child {
    background-color: #f7f7f7;
}

#filter .row:last-child>div:not(:last-child) {
    border-color: #eee;
}

.dark-mode #filter>.row:last-child {
    background-color: var(--bs-gray-700);
}
.dark-mode #filter>.row>div:hover {
    background-color: var(--bs-gray-900);
}
.dark-mode #filter > .row > div{
    border-color: #6c757d !important;
}


#filter>.row>div {
    transition: 250ms;
}

#filter>.row>div:hover {
    background: var(--bs-light);
}


#filter>.row>div:hover {
    background-color: var(--bs-light);
}

.filter-input_field:hover input {
    background-color: var(--bs-white);
}

.claim-input>label:hover .filter-input_field {
    background-color: var(--bs-light);
}

.claim-input>label:hover .filter-input_field input {
    color: var(--bs-gray-500);
}

.claim-input>label>.form-part__input {
    width: 100%;
    height: 100%;
    padding: 0;
    border: none;
    border-radius: 0;
    background-color: transparent;
}

.claim-input>label>.form-part__input:focus {
    outline: none;
    box-shadow: none;
}

.claim-input>label>.form-part__input::placeholder {
    color: #666;
}

.load-more-container {
    transition: 250ms;
}

.load-more-container:hover {
    background: var(--bs-light);
}

.load-more-container:hover button {
    background: var(--bs-primary);
    color: var(--bs-white);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.load-more-container button {
    width: 100%;
    position: relative;
    display: inline-block;
    padding: 10px 25px;
    color: var(--bs-white);
    background: var(--bs-primary);
    font-size: var(--bs-body-font-size);
    font-weight: var(--bs-body-font-weight);
    line-height: 1.42857143;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    vertical-align: middle;
    transition-duration: .25s;
    border-radius: 6px;
    border: 1px solid transparent;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
}

.load-more-container button:hover {
    background: var(--bs-primary);
    color: var(--bs-white);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.load-more-container button:active {
    transform: scale(0.9);
    transition: transform 0.2s;
}

#filter small{
    cursor: pointer;
    color: var(--bs-gray-500);
}
#filter small.active{
    color: var(--bs-primary);
}
</style>
